import React from "react";
import classes from './SuggestedAction.module.css';

function SuggestedAction({onClick, children}){
    return(
        <button type="button" onClick={onClick} className={`${classes['suggested-action']}`}>{children}</button>
    )
}

export default SuggestedAction;